export default "__VITE_ASSET__C3D6SgPV__"